<template>
	<div class="product">
		<div style="position: relative;min-height:40px;">
			<div style="width:84%;">
				<el-radio-group v-model="category_id" style="margin-bottom: 4px;" @change="tabClick">
					<el-radio-button :label="item.id" :key="item.id" v-for="(item) in categoryList">{{item.name}}</el-radio-button>
				</el-radio-group>
			</div>
			<el-button type="primary" plain class="addButtonClass3" @click="exportClick()">导出产品</el-button>
			<el-button type="primary" plain class="addButtonClass" @click="ClassificationClick()">分类管理</el-button>
			<el-button type="primary" plain class="addButtonClass2" @click="addClick()">新增产品</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" v-loading="loading">
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 4px;">{{(pageIndex-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				<el-table-column prop="model" label="产品型号" min-width="1%">
				</el-table-column>
				<el-table-column prop="username" label="创建人" min-width="1%">
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="操作" min-width="1%">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="detailClick(scope.row.id,scope.row)">查看</a>
						<a class="editClass" @click.prevent="deleteClick(scope.row.id,scope.row.model)">删除</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20" :current-page.sync="pageIndex">
			</el-pagination>
		</div>
		<!--弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false" style="margin-top: 0;">
			<el-form>
				<el-form-item label="型号" label-width="20%">
					<el-input type="text" v-model="model" autocomplete="off" @change="modelChange()"></el-input>
				</el-form-item>
				<el-form-item label="规约类型" label-width="20%">
					<el-select v-model="ruler_type" placeholder="请选择" style="width:100%">
						<el-option v-for="item in ruler_typeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="通信密码" label-width="20%">
					<el-input type="text" v-model="password" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="费率个数" label-width="20%">
					<el-input type="text" v-model="fee_num" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="用户类型" label-width="20%">
					<el-input type="text" v-model="user_type" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="波特率" label-width="20%">
					<el-select v-model="rate_type" placeholder="请选择" style="width:100%">
						<el-option v-for="item in rate_typeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="接线方式" label-width="20%">
					<el-select v-model="join_type" placeholder="请选择" style="width:100%">
						<el-option v-for="item in join_typeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="额定电压" label-width="20%">
					<el-input type="text" v-model="rated_v" autocomplete="off">
						<i slot="suffix" style="color: #000;font-style: normal;">V&nbsp;</i>
					</el-input>
				</el-form-item>
				<el-form-item label="额定电流" label-width="20%">
					<el-input type="text" v-model="rated_a" autocomplete="off">
						<i slot="suffix" style="color: #000;font-style: normal;">mA&nbsp;</i>
					</el-input>
				</el-form-item>
				<el-form-item label="资产号" label-width="20%">
					<el-input type="text" v-model="p_code" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="抄读方式" label-width="20%">
					<el-select v-model="parser_id" placeholder="请选择" style="width:100%" @change="getParserItemList(parser_id)">
						<el-option v-for="item in parserList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<!--<el-form-item label="事件方式" label-width="20%">
					<el-select v-model="value" placeholder="请选择" style="width:100%">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>-->
				<el-button size='small' plain type="primary" class="nowdataClass" @click="setNowData(parser_id)">配置实时数据</el-button>
				<div class="specilCheckBox">
					<div class="parserClass" v-for="item in parserItemList" v-if="item.checked==true">
						<!--<el-checkbox v-model="item.checked" :disabled="!parser_id">{{item.name}}</el-checkbox>-->
						<div class="nameClass2">{{item.code}}</div>
						<div class="nameClass2">{{item.code}}</div>
					</div>
				</div>
				<!--<el-form-item label="最大电流" label-width="20%">
					<el-input type="text" v-model="p_code" autocomplete="off"></el-input>
				</el-form-item>-->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
		<!--实时数据弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible10" :width="dialogWidth2" :close-on-click-modal="false">
			<div>
				<span style="display:inline-block;margin-bottom: 20px;">抄读方式：{{parserName}}</span>
				<div class="checkAllBox">
					<el-checkbox v-model="checkedAll" @change="checkedAllChange()">全选</el-checkbox>
				</div>
				<div :class="[item.selected?'parserClass2':'parserClass3']" v-for="item in parserItemList">
					<el-checkbox v-model="item.checked" @change="checkedRadioChange()">{{item.name}}</el-checkbox>
					<div :class="[item.selected?'nameClass33':'nameClass22']" v-if="item.selected==true">{{item.code}}</div>
					<div :class="[item.checked?'nameClass33':'nameClass22']" v-if="item.selected==false">{{item.code}}</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible10=false" class="confrim" type="primary">确认</el-button>
				<el-button @click="dialogFormVisible10=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import dataList from '../../../static/js/dataList.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			//TODO
			//this.getFun()
			//this.getFun2()
			if(this.$route.query.fI) {
				this.pageIndex = this.$route.query.fI
			}
			if(typeof(this.pageIndex) != 'number') {
				this.pageIndex = Number(this.pageIndex)
			}
			this.getCategoryList();
//			this.getParserList();
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
					this.dialogWidth2 = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
					this.dialogWidth2 = "80%"
				} else {
					this.dialogWidth = "34%"
					this.dialogWidth2 = "50%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
				this.dialogWidth2 = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
				this.dialogWidth2 = "80%"
			} else {
				this.dialogWidth = "34%"
				this.dialogWidth2 = "50%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false, //加载状态
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [],
				dialogFormVisible: false,
				title: '', //弹窗标题
				/*表单*/
				model: '', //型号
				ruler_type: '', //规约类型
				ruler_typeList: [{
						id: 0,
						name: '未知（0）'
					},
					{
						id: 1,
						name: 'DL/T 645-1997（1）'
					},
					{
						id: 2,
						name: 'DL/T 645—2007（2）'
					},
					{
						id: 3,
						name: 'DL/T 698.45（3）'
					},
					{
						id: 4,
						name: 'CJ/T 188—2004（4）'
					},
					{
						id: 5,
						name: 'ModBus（5）'
					},
				], //规约类型列表
				password: '123456020000', //通信密码
				fee_num: '', //费率个数
				user_type: '', //用户类型
				rate_type: '', //波特率
				rate_typeList: [{
						id: 255,
						name: '自适应（偶校验）'
					},
					{
						id: 0,
						name: '300bps（偶校验）'
					},
					{
						id: 1,
						name: '600bps（偶校验）'
					},
					{
						id: 2,
						name: '1200bps（偶校验）'
					},
					{
						id: 3,
						name: '2400bps（偶校验）'
					},
					{
						id: 4,
						name: '4800bps（偶校验）'
					},
					{
						id: 5,
						name: '7200bps（偶校验）'
					},
					{
						id: 6,
						name: '9600bps（偶校验）'
					},
					{
						id: 7,
						name: '19200bps（偶校验）'
					},
					{
						id: 8,
						name: '38400bps（偶校验）'
					},
					{
						id: 9,
						name: '57600bps（偶校验）'
					},
					{
						id: 10,
						name: '115200bps（偶校验）'
					},
					{
						id: 128,
						name: '300bps（无校验）'
					},
					{
						id: 129,
						name: '600bps（无校验）'
					},
					{
						id: 130,
						name: '1200bps（无校验）'
					},
					{
						id: 131,
						name: '2400bps（无校验）'
					},
					{
						id: 132,
						name: '4800bps（无校验）'
					},
					{
						id: 133,
						name: '7200bps（无校验）'
					},
					{
						id: 134,
						name: '9600bps（无校验）'
					},
					{
						id: 135,
						name: '19200bps（无校验）'
					},
					{
						id: 136,
						name: '38400bps（无校验）'
					},
					{
						id: 137,
						name: '57600bps（无校验）'
					},
					{
						id: 138,
						name: '115200bps（无校验）'
					}
				], //波特率列表
				join_type: '', //接线方式
				join_typeList: [{
						id: 0,
						name: '未知（0）'
					},
					{
						id: 1,
						name: '单相（1）'
					},
					{
						id: 2,
						name: '三相三线（2）'
					},
					{
						id: 3,
						name: '三相四线（3）'
					},
				], //接线方式列表
				rated_v: '', //额定电压
				rated_a: '', //额定电流
				p_code: '000000000000', //资产号
				parser_id: '', //抄读方式
				parserList: [], //抄读方式列表
				dialogWidth: '34%', //dialog的宽度
				dialogWidth2: '50%', //dialog的宽度
				editId: null, //编辑的id
				category_id: '', //分类id
				categoryList: [], //分类列表
				dialogFormVisible10: false,
				checkedAll: false,
				parserItemList: [], //抄读项列表
				productReadList: [], //产品实时抄读列表
				parserName: '', //产品抄读合集名称
				product_id: '', //产品id
			}
		},

		methods: {
			//加载的动画
			openFullScreen() {
				this.loadingAdd = this.$loading({
					lock: true,
					text: '',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0)'
				});
			},
			//导出
			exportClick() {
				let config = headers.headers('exportAll')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				this.openFullScreen();
				var params = {
					path: '/mnt/xvdb/html/zkepA/storage/excel/',
				}
				//console.log(params)
				axios.get(this.http + '/zkep2/product/exportAll', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.openFullScreen();
					//console.log(res)
					if(res.data.res == 1) {
						var index = res.data.file.lastIndexOf("excel");
						var fileName = res.data.file.substring(index + 6, res.data.file.length)
						//window.location.href = this.http.slice(0, -5) + '/zkepA/storage/excel' + fileName
						//window.location.href = 'http://www.380v.top' + '/storage/excel' + fileName
						/*防止下载txt文件直接打开而不是是下载*/
						/*注意：本地运行，还是会直接打开，部署到服务器就好啦！*/
//						let fileUrl = this.http.slice(0, -5) + '/zkepA/storage/excel' + fileName;
						/*let fileUrl = 'http://www.380v.top' + '/storage/excel' + fileName;*/
						let fileUrl = res.data.filePath
						let fileNameArray = fileUrl.split('/');
						let fileName = fileNameArray[fileNameArray.length - 1];
						let element = document.createElement('a');
						element.style.display = 'none';
						element.setAttribute('href', fileUrl);
						element.setAttribute('download', fileName);
						document.body.appendChild(element);
						element.click();
						document.body.removeChild(element);
						setTimeout(() => {
							this.loadingAdd.close();
							this.$message({
								type: 'success',
								message: '导出成功'
							});
						}, 3000);

					} else {
						this.$message({
							type: 'error',
							message: res.data.msg + '!'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			/*
			 * 配置实时数据
			 * */
			//全选、全不选
			checkedAllChange() {
				if(this.checkedAll == true) {
					this.parserItemList.forEach(item => {
						item.checked = true
					})
				} else {
					this.parserItemList.forEach(item => {
						item.checked = false
					})
				}
			},
			//单选
			checkedRadioChange(val, signVal) {
				var checkedArr = []
				this.parserItemList.forEach(item => {
					if(item.checked == true) {
						checkedArr.push(item)
					}
				})
				if(checkedArr.length == this.parserItemList.length) {
					this.checkedAll = true
				} else {
					this.checkedAll = false
				}
			},
			//配置实时数据
			setNowData(parser_id) {
				if(this.parser_id) {
					this.title = "实时抄读设置"
					this.dialogFormVisible10 = true
					this.parserList.forEach(item => {
						if(item.id == parser_id) {
							this.parserName = item.name
						}
					})
				} else {
					this.$message('请先选择抄读方式！');
					this.parserName = ''
				}
			},
			//抄读项列表
			getParserItemList(parser_id) {
				this.checkedAll = false
				var params = {
					pageSize: -1,
					pageIndex: 1,
					parser_id: parser_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_item/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							item.selected = false
							item.checked = false
						})
						this.parserItemList = res.data
					} else {
						this.parserItemList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getFun() {
				var params = {}
				axios.get('/lanjian/v1/project', {
					params
				}).then(res => {
					console.log(res)
				}).catch(err => {
					console.log(err)
				})
			},
			getFun2() {
				let params = {
					name: 33,
					join_date: '2022-05-24',
					capacity: 44,
					v_lev: 55,
					device_id: 66,
					v_rate: 77,
					a_rate: 88,
					fpath: '1111111',
					project_code: 'dcdcd',
					tenant_id: 1,
					customer_code: 'c1',
					creator: 5
				}
				//console.log(params)
				axios.post('/lanjian/v1/project',
					JSON.stringify(params), {
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(res => {
					console.log(res)
				}).catch(err => {
					console.log(err)
				})
			},
			//型号光标离开触发
			modelChange() {
				var params = {
					model: this.model
				}
				let config = headers.headers('getByModel')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product/getByModel', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						this.$message('该型号已存在,请重新输入型号！');
						this.notDo = true
						this.model = ''
					} else {
						this.notDo = false
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//分类列表
			getCategoryList() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.categoryList = res.data
						this.categoryList.forEach(item => {
							//if(item.show_type == '1') {
							//this.category_id = item.id
							//this.getList();
							//}
						})
						if(window.sessionStorage.getItem('category_id')) {
							this.category_id = window.sessionStorage.getItem('category_id')
						} else {
							this.category_id = this.categoryList[0].id
						}
						this.getList();
						this.getParserList()
					} else {
						this.categoryList = []
						this.category_id = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//抄读方式列表
			getParserList() {
				console.log(this.category_id)
				this.loading = true;
				var params = {
					pageSize: -1,
					pageIndex: 1,
					category_id: this.category_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.parserList = res.data
					} else {
						this.parserList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//总条数
			getTotal() {
				var params = {
					category_id: this.category_id
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					category_id: this.category_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//tab的点击
			tabClick(val) {
				this.pageIndex=1
				this.category_id = val;
				window.sessionStorage.setItem('category_id', this.category_id)
				this.getList();
				this.getParserList()
			},
			//新增产品
			addClick() {
				this.title = "新增设备"
				this.dialogFormVisible = true
				this.emptyList();
			},
			//保存
			save() {
				/*创建时间的处理*/
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				var params = {
					category_id: this.category_id,
					model: this.model, //型号
					ruler_type: this.ruler_type, //规约类型
					password: this.password, //通信密码
					fee_num: this.fee_num, //费率个数
					user_type: this.user_type, //用户类型
					rate_type: this.rate_type, //波特率
					join_type: this.join_type, //接线方式
					rated_v: this.rated_v, //额定电压
					rated_a: this.rated_a, //额定电流
					p_code: this.p_code, //资产号
					parser_id: this.parser_id, //抄读方式
					isrepair: 0,
					special1: 0,
					special2: 0,
					ischeck: 0,
					manager_id: manager_id,
					create_time: timestamp,
					status: 1,
					version: 0
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.model && this.ruler_type !== undefined && this.password && this.fee_num && this.user_type && this.rate_type !== undefined && this.join_type !== undefined && this.rated_v && this.rated_a && this.p_code && this.parser_id) {
					axios.post(this.http + '/zkep2/product/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible = false
							this.product_id = res.data.id;
							if(this.product_id) {
								this.delByProduct();
							}
							this.getList()
						} else {
							this.$message('新增失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入必填项！');
				}
			},
			//根据产品id删除所有 数据项
			delByProduct() {
				var config = headers.headers('delByProduct')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/product_read/delByProduct',
					qs.stringify({
						product_id: this.product_id
					}), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					this.productReadSave();
				}).catch(err => {
					console.log(err)
				})
				var arrAdd = []
				this.parserItemList.forEach(item => {
					if(item.checked == true) { //添加
						arrAdd.push(item)
					}
				})
			},
			//产品实时抄读内容保存
			productReadSave() {
				var arrAdd = []
				this.parserItemList.forEach(item => {
					if(item.checked == true) { //添加
						arrAdd.push(item)
					}
				})
				//console.log(arrAdd)
				var timestamp = Date.parse(new Date());
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				for(var i = 0; i < arrAdd.length; i++) {
					axios.post(this.http + '/zkep2/product_read/save',
						qs.stringify({
							product_id: this.product_id,
							parser_item_id: arrAdd[i].id,
							create_time: timestamp,
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						this.getList();
						if(res.data.id) {} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//清空
			emptyList() {
				this.model = ''
				this.ruler_type = ''
				this.password = '123456020000'
				this.fee_num = ''
				this.user_type = ''
				this.rate_type = ''
				this.join_type = ''
				this.rated_v = ''
				this.rated_a = ''
				this.p_code = '000000000000'
				this.parser_id = ''
				this.parserItemList = []
			},
			//删除
			deleteClick(id, model) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: id,
					model: model + '_' + id,
					status: 0
				}
				//console.log(params)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/product/save', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getList();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//查看
			detailClick(id, list) {
				this.$router.push({
					path: '/product/productDetail',
					name: 'ProductDetail',
					query: {
						id: id,
						category_id: this.category_id,
						fI: this.pageIndex
						//list: JSON.stringify(list), //解决页面跳转时携带对象参数，在刷新页面时对象不展示的问题：（先把对象转成字符串，再JSON.parse转成对象）
					}
				})
			},
			//分类跳转
			ClassificationClick() {
				this.$router.push({
					path: '/product/classification',
					name: 'Classification'
				})
			},
		}
	}
</script>

<style>
	.product {
		height: 100%;
		padding: 3.2% 12% 0 12%;
		position: relative;
	}
	
	.product .el-table th {
		color: #000;
	}
	
	.product .el-table {
		font-size: 12px;
	}
	
	.product .el-table th,
	.product .el-table td,
	.product .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.product .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
	
	.product .addButtonClass {
		position: absolute;
		bottom: 4px;
		right: 96px;
		padding: 10px 12px;
		font-size: 13px;
	}
	
	.product .addButtonClass2 {
		position: absolute;
		bottom: 4px;
		right: 8px;
		padding: 10px 12px;
		font-size: 13px;
	}
	
	.product .addButtonClass3 {
		position: absolute;
		bottom: 4px;
		right: 185px;
		padding: 10px 12px;
		font-size: 13px;
	}
	
	.product .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.product .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.product .el-dialog__title {
		color: #999;
	}
	
	.product .el-dialog__footer {
		text-align: center;
	}
	
	.product .pagination {
		text-align: center;
	}
	
	.product .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	/*tabs*/
	
	.product .el-radio-button:first-child .el-radio-button__inner {
		border-radius: 0;
	}
	
	.product .el-radio-button:last-child .el-radio-button__inner {
		border-radius: 0;
	}
	
	.product .el-radio-button__inner {
		background-color: #eee;
		padding: 10px 20px;
		min-width: 70px;
		font-size: 13px;
	}
	
	.product .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: #457ED8;
		border-color: #457ED8;
	}
	
	.product .el-input__inner {
		height: 36px;
		line-height: 36px;
	}
	
	.product .el-form-item {
		margin-bottom: 12px;
	}
	
	.product .nowdataClass {
		margin-bottom: 10px;
		margin-left: 4px;
	}
	/*复选框（深色）*/
	
	.product .specilCheckBox .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
		color: #000;
	}
	
	.product .specilCheckBox .el-checkbox__inner {
		border: 1px solid #0079DD!important;
		background-color: #0079DD;
		border-radius: 0!important;
	}
	
	.product .specilCheckBox .el-checkbox__input.is-checked .el-checkbox__inner,
	.product .specilCheckBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #0079DD;
		border-color: #0079DD!important;
	}
	
	.product .nameClass2 {
		font-size: 12px;
		height: 18px;
		line-height: 18px;
		text-align: center;
	}
	
	.product .nameClass22 {
		margin-left: 24px;
		font-size: 12px;
		height: 0px;
		line-height: 0px;
	}
	
	.product .nameClass33 {
		color: #439DFD;
		margin-left: 24px;
		font-size: 12px;
		height: 0px;
		line-height: 0px;
	}
	
	.product .parserClass {
		display: inline-block;
		width: 140px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 3px 6px 4px;
		border: 1px solid #439DFD;
		border-radius: 4px;
	}
	
	.product .checkAllBox {
		margin-left: 2px;
		margin-bottom: 16px;
	}
	
	.product .checkAllBox .el-checkbox__inner,
	.product .checkAllBox2 .el-checkbox__inner {
		border: 1px solid #6a6a6a!important;
		background-color: #6a6a6a;
		border-radius: 0!important;
	}
	/*加载图标*/
	
	.el-loading-spinner {
		font-size: 46px;
	}
	
	.el-loading-spinner i {
		color: #34495e!important;
		opacity: 0.7;
	}
	
	.product .checkAllBox .el-checkbox__input.is-checked+.el-checkbox__label,
	.product .checkAllBox2 .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #409eff;
	}
	
	.product .checkAllBox .el-checkbox__label,
	.product .checkAllBox2 .el-checkbox__label {
		color: #6a6a6a;
	}
	
	.product .parserClass2 {
		display: inline-block;
		width: 210px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 10px 6px 4px;
		border: 1px solid #439DFD;
		border-radius: 4px;
	}
	
	.product .parserClass3 {
		display: inline-block;
		width: 210px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 10px 6px 4px;
		border: 1px solid #6A6A6A;
		border-radius: 4px;
	}
	
	.product .el-checkbox__input.is-disabled+span.el-checkbox__label {
		color: #666;
		cursor: not-allowed;
	}
	
	.product .parserClass3 .el-checkbox {
		color: #6A6A6A;
	}
	
	.product .parserClass3 .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
	}
	
	.product .parserClass3 .el-checkbox__inner {
		border: 1px solid #6A6A6A!important;
		background-color: #6A6A6A;
		border-radius: 0!important;
	}
	
	.product .parserClass3 .el-checkbox__input.is-checked .el-checkbox__inner,
	.product .parserClass3 .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6A6A6A;
		border-color: #6A6A6A!important;
	}
	
	.product .transDialog .el-dialog__footer {
		text-align: right;
	}
</style>


// WEBPACK FOOTER //
// src/components/Product/Product.vue